export type SentimentPromptInput = {
  referenceNumber: string
  submissionText: string
  issueCategory?: string
  affectedSystem?: string
  userPriority?: string
  messages: Array<{ role: string; body: string }>
}

export function buildSentimentPrompt(input: SentimentPromptInput): {
  system: string
  user: string
} {
  const thread = input.messages
    .map((m, i) => `Message ${i + 1} (${m.role}):\n${m.body}`)
    .join('\n\n')

  const contextFields = [
    input.issueCategory && `Issue category: ${input.issueCategory}`,
    input.affectedSystem && `Affected system: ${input.affectedSystem}`,
    input.userPriority && `User-declared priority: ${input.userPriority}`,
  ]
    .filter(Boolean)
    .join('\n')

  return {
    system: [
      'You assess urgency and sentiment in manufacturing support tickets to help experts prioritise their inbox.',
      'urgency_score: 0 = routine, 1 = production-halting or safety-critical.',
      'sentiment_score: -1 = highly distressed/frustrated, 0 = neutral, 1 = calm/positive.',
      'sentiment_label: choose the single label that best captures the submitter\'s tone.',
      'priority_band: your recommended triage priority, factoring in urgency, sentiment, and declared priority. May differ from user-declared priority.',
      'reasoning: one or two sentences explaining your assessment.',
      'Base your assessment on observable signals in the text — do not invent facts.',
    ].join(' '),
    user: [
      `Ticket reference: ${input.referenceNumber}`,
      contextFields ? `\nContext:\n${contextFields}` : '',
      '',
      'Conversation thread:',
      thread,
    ]
      .filter((l) => l !== '')
      .join('\n'),
  }
}
